export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.organization': 'Organization',
  'menu.user': 'User Management',
  'menu.system': 'System Management',
  'menu.system.permission': 'Permission Management',
  'menu.system.role': 'Role Management',
  'menu.system.tag': 'Tag Management',
  'menu.system.calendar': 'Calendar Management',
  'menu.vacation': 'Vacation Management',
  'menu.vacation.balance': 'Vacation Balance',
  'menu.vacation.quota': 'Quota Configuration',
  'menu.vacation.expiry': 'Expiry',
  'menu.vacation.typeExpiry': 'Type Expiry Config',
  'menu.vacation.parentalLeaveConfig': 'Parental Leave Config',
  'menu.vacation.parentalLeaveHistory': 'Parental Leave History',
  'menu.approval': 'Approval Management',
  'menu.approval.templates': 'Approval Templates',
  'menu.approval.my': 'My Approvals',
  'menu.approval.applications': 'Approval Applications',
  'menu.approval.department': 'Department Approval',
  'menu.approval.submit': 'Submit Approval',
  'menu.vehicle': 'Vehicle Management',
  'menu.vehicle.applications': 'Vehicle Usage Records',
  'menu.vehicle.refuelRecords': 'Refuel Records',
  'menu.vehicle.repairApplications': 'Vehicle Repair Records',
  'menu.vehicle.managers': 'Vehicle Managers',
  'menu.document': 'Document Management',
  'menu.document.applications': 'Document Records',
  'menu.document.statistics': 'Document Statistics',
  'menu.document.numberConfig': 'Document Number Config',
  'menu.incomingDocument': 'Incoming Document Circulation',
  'menu.incomingDocument.applications': 'Incoming Document Records',
  'menu.shift': 'Shift Management',
  'menu.profile': 'Employee Profile',
  'menu.test': 'Test Module',
};
